import { CardContent, Card, Popover } from '@mui/material';
import React from 'react';

interface CardPopoverProps {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    children: React.ReactNode;
    className?: string;
}

function CardPopover({ anchorEl, onClose, children, className }: CardPopoverProps) {
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <Card
                className={className}
                sx={{
                    height: '50%',
                    overflow: 'auto',
                    minWidth: '200px',
                    textAlign: 'center',
                    paddingBottom: 2,
                    '& .MuiCardContent-root': {
                        padding: 0,
                    },
                    '& .closeIcon': {
                        '&:hover': {
                            backgroundColor: 'lightgray',
                            borderRadius: '50%',
                        },
                        maxWidth: '18px',
                        maxHeight: '18px',
                        padding: '3px',
                        float: 'right',
                        top: '8px',
                        position: 'absolute',
                        right: '8px',
                    },
                    '&.lastUploadPopover': {
                        overflow: 'auto',
                    },
                    '&.lastUploadPopover.hasRows': {
                        minWidth: '80vw',
                    },
                }}
            >
                <CardContent>{children}</CardContent>
            </Card>
        </Popover>
    );
}

export default CardPopover;
